import { ReactNode } from 'react';

import { CopyButton } from '../../../components/general/CopyButton.tsx';
import { HeadingWithTag } from '../../../components/general/HeadingWithTag.tsx';
import { AccordionWithHeading } from '../../../components/general/index.ts';
import { LabelValue } from '../../../components/general/LabelValue.tsx';
import { type ThemaFromThemaRouter } from '../../../dtos.ts';
import { formatDate } from '../../../utils/index.ts';

type ThemaEigenschaftenCardProps = {
  readonly thema: ThemaFromThemaRouter;
};

const printAvendooKursfreigabeId = (thema: Pick<ThemaFromThemaRouter, 'avendooKursfreigabeId'>): ReactNode =>
  thema.avendooKursfreigabeId ? (
    <>
      {thema.avendooKursfreigabeId}
      {thema.avendooKursfreigabeId && <CopyButton text={thema.avendooKursfreigabeId} />}
    </>
  ) : null;

export const ThemaEigenschaftenCard = (props: ThemaEigenschaftenCardProps) => {
  const { thema } = props;
  const data = [
    ['SAP-ID (D)', thema.veranstaltungstypSapId.toString()],
    ['AKA-Modul-ID', thema.akaModulId],
    ['Letzte Änderung in Viva', formatDate(thema.updatedAt, true)],
    ['Sprache', thema.sprachen.join(', ')],
    ['Avendoo-Kursfreigabe-ID', thema.avendooKursfreigabeId ? printAvendooKursfreigabeId(thema) : null],
  ] as const;

  return (
    <AccordionWithHeading heading={<HeadingWithTag heading={'Eigenschaften'} tag="cserv" />} noAccordion>
      <div className="grid grid-cols-3 gap-16">
        {data.map(([label, value]) =>
          value ? <LabelValue label={label} value={value} key={label} /> : <div key={label} />,
        )}
      </div>
    </AccordionWithHeading>
  );
};
